import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import "../index.css"


const Footer = () => {
  return (<div className="footer-wrapper">
   


    
      
  
  
  <div className="social-links">
    
{/* <FontAwesomeIcon icon="fa-brands fa-twitter" /> */}
<i className='fa-brands fa-discord'></i>
<FontAwesomeIcon icon="fa-brands fa-twitter" />

<div className="fio-affiliate">
{/* <p className="blue-shadow back-link no-over">FIO Protocol<a href='https://dashboard.fioprotocol.io/ref/vqqe1'>Domain Link</a> */}
<p className="blue-shadow back-link no-over">

<ul className='ul-links'>

<header>Web Links</header>
<li>

<a href='https://www.mvmclx.com'>https://www.mvmclx.com</a>

</li>

<li>

<a href='https://portfolio-mvmclx.vercel.app'>
https://portfolio-mvmclx.vercel.app

</a>

</li>
<li>

<a href='https://best-dollar-spent.onrender.com'>
https://best-dollar-spent.onrender.com
</a>


</li>
<li>

<a href='https://dollar-a-week.vercel.app'>
https://dollar-a-week.vercel.app

</a>

</li>
</ul>

</p>
  </div>


  <div className="footer links">
    <ul>
<li>  <a href="/shoutouts">References / Attributes </a></li>
<li className="colored-li-no-p">╨</li>
 <li> <a href="/sitemap">Sitemap  </a></li>
<li className="colored-li-no-p">╨</li>
<li id='ip'><a href="#" id="ip"></a></li>
 <p className="colored-li left-text no-over">By mVmClX@gmail.com</p>

 </ul>
</div>
    </div>







  
  
  
  
</div>
  );
}

export default Footer;